(function ($) {

	$(function () {

		/** =============================================
		 *  PARTNERS SLIDER ON PROJECTS SINGLE
		 *  ============================================= */

		$('.logo-slider').slick({
			autoplay: true,
			speed: 1200,
			slidesToScroll: 4,
			slidesToShow: 4,
			autoplaySpeed: 8000,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});

		/** =============================================
		 *  PROJECTS PAGE MINIMAL GALLERY
		 *  ============================================= */

		$(".page-projects .img-opener").on("click", function (e) {
			var offset = 7;
			if ($(window).width() <= 1366) {
				offset = 0;
			}

			$(this).parents(".equal-row").toggleClass("open");

			if ($(this).parents(".equal-row").hasClass("open")) {
				var toHeight = $(this).parent().siblings(".long-text").outerHeight() - offset;
				$(this).parent().css("height", toHeight);
			}
			else {
				$(this).parent().css("height", "auto");
			}

			if ($(this).hasClass("fa-angle-right")) {
				$(this).removeClass("fa-angle-right");
				$(this).addClass("fa-angle-left")
			}
			else if ($(this).hasClass("fa-angle-left")) {
				$(this).removeClass("fa-angle-left");
				$(this).addClass("fa-angle-right")
			}
		});

		$(".gallery .bg").on("click", function (e) {
			if ($(window).width() >= 769) {
				var old_src = $(".big-pic .bg").css('background-image');
				var new_src = $(this).css('background-image');
				$(".big-pic .bg").css("background-image", new_src);
				$(this).css("background-image", old_src);
			}
		});

		/** =============================================
		 *  INFINITE POST LOADER BASED ON SCROLLING
		 *  CURRENTLY NOT IN USE, SAVE FOR FUTURE USE
		 *  ============================================= */

		/* $('.post-listing').append('<span class="load-more"></span>');
		 var button = $('.post-listing .load-more');
		 var page = 2;
		 var loading = false;
		 var scrollHandling = {
			 allow: true,
			 reallow: function () {
				 scrollHandling.allow = true;
			 },
			 delay: 400 //(milliseconds) adjust to the highest acceptable value
		 };


		 function fillUpNewsResults(res, cb) {
			 $('.post-listing #loader').remove();
			 $('.post-listing .container-fluid .row').append(res.data.content);
			 cb();
		 }

		 var stop_ajax = false;

		 if ($(".home").length > 0) {
			 $(window).scroll(function () {
				 if (!loading && scrollHandling.allow && !stop_ajax) {
					 scrollHandling.allow = false;
					 setTimeout(scrollHandling.reallow, scrollHandling.delay);
					 var offset = $(button).offset().top - $(window).scrollTop();
					 if (2000 > offset) {
						 loading = true;


						 var data = {
							 action: 'ajax_loadmoreposts',
							 nonce: loadmoreposts_ajax.nonce,
							 page: page,
							 query: loadmoreposts_ajax.query
						 };
						 $.ajax({
							 type: 'POST',
							 url: loadmoreposts_ajax.url,
							 data: data,
							 success: function (res) {
								 //if the result count is smaller than 8, than we don't need to send a request anymore
								 if (res.data.count < 8) {
									 stop_ajax = true;
								 }
								 fillUpNewsResults(res, function () {
									 //get the results and reinit the scroller based on the new elements
									 initScroller();
								 });
								 $('.post-listing').append(button);
								 page = page + 1;
								 loading = false;
							 },
							 //before we send our ajax request, show a spinner to the user
							 beforeSend: function () {
								 $('.post-listing').append('<div id="loader" class="text-xs-center"><i class="fa fa-circle-o-notch fa-spin" style="font-size:24px; color: black;"></i></div>');
							 }
						 });
					 }
				 }
			 });
		 }*/

		/** =============================================
		 *  PROJECTS FILTER
		 *  ============================================= */

		/**
		 *  INFINITE POST LOADER BASED ON SCROLLING
		 *  CURRENTLY NOT IN USE, SAVE FOR FUTURE USE
		 **/
		/*
		 $('.projects-lister').append('');
		 var button = $('.projects-lister .load-more');
		 var page = 2;
		 var loading = false;
		 var scrollHandling = {
			 allow: true,
			 reallow: function () {
			 	scrollHandling.allow = true;
			 },
			 delay: 400 //(milliseconds) adjust to the highest acceptable value
		 };

		 var stop_ajax = false;

		 if ($(".page-projects").length > 0) {
			 $(window).scroll(function () {
				 if (!loading && scrollHandling.allow && !stop_ajax) {
					 scrollHandling.allow = false;
					 setTimeout(scrollHandling.reallow, scrollHandling.delay);
					 var offset = $(button).offset().top - $(window).scrollTop();
					 if (2000 > offset) {
						 loading = true;

						 var data = {
							 action: 'ajax_loadmoreprojects',
							 nonce: loadmoreprojects_ajax.nonce,
							 page: page,
							 query: loadmoreprojects_ajax.query
						 };
						 $.ajax({
							 type: 'POST',
							 url: loadmoreprojects_ajax.url,
							 data: data,
							 success: function (res) {
								 //if the result count is smaller than 8, than we don't need to send a request anymore
								 if (res.data.count < 8) {
									 stop_ajax = true;
								 }
								 $('.projects-lister #loader').remove();
								 $('.projects-lister').append(res.data.content);
								 $('.projects-lister').append(button);
								 page = page + 1;
								 loading = false;
							 },
							 //before we send our ajax request, show a spinner to the user
							 beforeSend: function () {
							 	$('.projects-lister').append('<div id="loader" class="text-xs-center"><i class="fa fa-circle-o-notch fa-spin" style="font-size:24px; color: black;"></i></div>');
							 }
						 });
					 }
				 }
			 });
		 }*/

		/**
		 *  PROJECTS FILTER FUNCTIONING
		 **/

		function fillUpResults(res, cb) {
			$(".projects-lister").removeClass("loading");
			$(".projects-lister").html(res.data.return_projects);
			$(".projects-count").text(res.data.count);
			cb();
		}

		var getUrlParameter = function getUrlParameter(sParam) {
			var sPageURL = decodeURIComponent(window.location.search.substring(1)),
				sURLVariables = sPageURL.split('&'),
				sParameterName,
				i;

			for (i = 0; i < sURLVariables.length; i++) {
				sParameterName = sURLVariables[i].split('=');

				if (sParameterName[0] === sParam) {
					return sParameterName[1] === undefined ? true : sParameterName[1];
				}
			}
		};

		//country from url
		var search_country = getUrlParameter('c');
		if(!search_country){
			search_country = 'all';
		}

		$("select[name='project-country']").val(search_country);
		$("select[name='project-country']").selectric('refresh');

		//category from url
		var search_proj = getUrlParameter('p');
		if(!search_proj){
			search_proj = 'all';
		}

		$("select[name='project-category']").val(search_proj);
		$("select[name='project-category']").selectric('refresh');

		//status from url
		var search_stat = getUrlParameter('st');
		if(!search_stat){
			search_stat = 'all';
		}

		$("select[name='project-status']").val(search_stat);
		$("select[name='project-status']").selectric('refresh');

		//company from url
		var search_comp = getUrlParameter('co');
		if(!search_comp){
			search_comp = 'all';
		}

		$("select[name='project-company']").val(search_comp);
		$("select[name='project-company']").selectric('refresh');


		
		//if there has been a change event on one of the project filter inputs
		$(".projects-filter-screen select").on("change", function () {

			var data = {
				action: 'ajax_filterprojects',
				nonce: filterprojects_ajax.nonce,
				project_status: $("select[name='project-status']").val(),
				project_category: $("select[name='project-category']").val(),
				project_country: $("select[name='project-country']").val(),
				project_company: $("select[name='project-company']").val()
			};

		

			var hash = '?co=' + $("select[name='project-company']").val() + '&c=' + $("select[name='project-country']").val() + '&p='+$("select[name='project-category']").val() + '&st='+$("select[name='project-status']").val();

			window.history.replaceState(null, null, hash);

			$.ajax({
				type: 'POST',
				url: filterprojects_ajax.url,
				data: data,
				success: function (res) {
					fillUpResults(res, function () {
						//get the results and reinit the scroller based on the new elements
						initScroller();
					});
				},
				//before we send our ajax request, show a spinner to the user and also reduce the opacity on previous project results
				beforeSend: function () {
					$(".projects-lister").addClass("loading");
					$('.projects-lister').append('<div id="loader" class="text-xs-center"><i class="fa fa-circle-o-notch fa-spin" style="font-size:24px; color: white;"></i></div>');
				}
			});
		});

		//when filter values come from url
		$("select[name='project-category']").change();
		$("select[name='project-country']").change();
		$("select[name='project-status']").change();
		$("select[name='project-company']").change();

		var projects_cnt = $(".projects-lister .project").length;
		$(".projects-filter-screen .projects-count").text(projects_cnt);

		$(".projects-filter-screen select").selectric();

		//reset all selects to their default value
		/*$(".projects-filter-screen .selectric-wrapper .selectric-scroll li[data-index='0']").each(function () {
			if (!$(this).hasClass("selected")) {
				$(this).trigger("click");
			}
		});*/

	});

})(jQuery);